@for (item of _items; track item) {
    <kui-snackbar-item
        @fade
        [title]="item.title"
        [description]="item.description"
        [icon]="item.icon"
        [duration]="item.duration"
        [actionText]="item.actionText"
        [style]="item.style"
        (onActionClicked)="handleActionClicked(item)"
        (onClosed)="removeItem(item)"
    ></kui-snackbar-item>
}
